export const FlagFR = ({ className = "w-7 h-5" }) => (
  <svg viewBox="0 0 3 2" className={`${className} rounded-[4px] shadow-sm`} aria-hidden="true">
    <rect width="1" height="2" fill="#0055A4" /><rect x="1" width="1" height="2" fill="#fff" /><rect x="2" width="1" height="2" fill="#EF4135" />
  </svg>
);

export const FlagEN = ({ className = "w-7 h-5" }) => (
  <svg viewBox="0 0 60 40" className={`${className} rounded-[4px] shadow-sm`} aria-hidden="true">
    <rect width="60" height="40" fill="#012169" />
    <path d="M0 0L60 40M60 0L0 40" stroke="#fff" strokeWidth="8" />
    <path d="M0 0L60 40M60 0L0 40" stroke="#C8102E" strokeWidth="3" />
    <path d="M30 0v40M0 20h60" stroke="#fff" strokeWidth="12" />
    <path d="M30 0v40M0 20h60" stroke="#C8102E" strokeWidth="7" />
  </svg>
);

export const FlagAll = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="10" fill="#38B6FF" />
    <path d="M7 8c2 0 3 1 3 3s2 2 2 4-1 3 0 5M14 4c0 2 2 3 4 3M16 13c1 1 3 1 4 0" stroke="#4CC417" strokeWidth="2.4" fill="none" strokeLinecap="round" />
  </svg>
);

export const LangBadge = ({ lang, testId }) => (
  <span data-testid={testId} className="inline-flex items-center gap-1.5 rounded-full bg-white/95 px-2.5 py-1 text-xs font-bold text-[#1E2A5A] shadow">
    {lang === "en" ? <FlagEN className="w-5 h-3.5" /> : <FlagFR className="w-5 h-3.5" />}
    {lang === "en" ? "EN" : "FR"}
  </span>
);
